import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "payment-filter__presets" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Ждут оплаты ")
const _hoisted_3 = { class: "text-muted" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" просрочен ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Подтвердить оплату ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" PDF ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Пересобрать PDF ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Выпустить акт ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Аннулировать ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Заказ ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_payment_status_tag = _resolveComponent("payment-status-tag")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_new_tab_link = _resolveComponent("new-tab-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_payment_list_layout = _resolveComponent("payment-list-layout")!
  const _component_payment_form_dialog = _resolveComponent("payment-form-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_payment_list_layout, {
      page: _ctx.page,
      pages: _ctx.pages,
      "per-page": _ctx.perPage,
      total: _ctx.total,
      onApply: _ctx.apply,
      onReset: _ctx.reset,
      onPageChange: _ctx.setPage
    }, {
      filter: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_button, {
            size: "small",
            type: _ctx.isUnpaidPreset ? 'primary' : '',
            onClick: _ctx.showUnpaid
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["type", "onClick"])
        ]),
        _createVNode(_component_el_select, {
          modelValue: _ctx.filters.type,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.type) = $event)),
          clearable: "",
          placeholder: "Тип"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              label: "Счёт",
              value: "invoice"
            }),
            _createVNode(_component_el_option, {
              label: "Акт",
              value: "act"
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_select, {
          modelValue: _ctx.filters.status,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.status) = $event)),
          multiple: "",
          clearable: "",
          placeholder: "Статус"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusOptions, (o) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: o.value,
                label: o.label,
                value: o.value
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_input, {
          modelValue: _ctx.filters.number,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.number) = $event)),
          placeholder: "Номер",
          clearable: ""
        }, null, 8, ["modelValue"]),
        _createVNode(_component_el_input, {
          modelValue: _ctx.filters.inn,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.inn) = $event)),
          placeholder: "ИНН",
          clearable: ""
        }, null, 8, ["modelValue"]),
        _createVNode(_component_el_input, {
          modelValue: _ctx.filters.user_id,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.user_id) = $event)),
          placeholder: "ID пользователя",
          clearable: ""
        }, null, 8, ["modelValue"]),
        _createVNode(_component_el_input, {
          modelValue: _ctx.filters.order_id,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.order_id) = $event)),
          placeholder: "ID заказа",
          clearable: ""
        }, null, 8, ["modelValue"]),
        _createVNode(_component_el_date_picker, {
          modelValue: _ctx.filters.issued_from,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters.issued_from) = $event)),
          type: "date",
          "value-format": "YYYY-MM-DD",
          placeholder: "Выставлен с"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_el_date_picker, {
          modelValue: _ctx.filters.issued_to,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters.issued_to) = $event)),
          type: "date",
          "value-format": "YYYY-MM-DD",
          placeholder: "Выставлен по"
        }, null, 8, ["modelValue"])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          border: "",
          data: _ctx.items,
          "table-layout": "fixed"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "Тип",
              width: "80"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(row.type === 'invoice' ? 'Счёт' : 'Акт'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "№",
              prop: "number",
              width: "130"
            }),
            _createVNode(_component_el_table_column, {
              label: "Статус",
              width: "140"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_payment_status_tag, {
                  kind: "document",
                  status: row.status
                }, null, 8, ["status"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Покупатель",
              "min-width": "220"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(row.buyer && row.buyer.name) + " ", 1),
                _createElementVNode("div", _hoisted_3, "ИНН " + _toDisplayString(row.buyer && row.buyer.inn), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Сумма",
              width: "140",
              align: "right"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(_ctx.money(row.total)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Выставлен",
              width: "130"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(_ctx.date(row.issued_at)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Оплатить до",
              width: "150"
            }, {
              default: _withCtx(({ row }) => [
                (row.type === 'invoice')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.date(row.due_at)) + " ", 1),
                      (_ctx.isOverdue(row))
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 0,
                            size: "mini",
                            type: "danger"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_4
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Действия",
              width: "560"
            }, {
              default: _withCtx(({ row }) => [
                (row.type === 'invoice' && row.status === 'issued')
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      size: "small",
                      type: "success",
                      onClick: ($event: any) => (_ctx.openConfirm(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_button, {
                  size: "small",
                  loading: _ctx.busyId === row.id,
                  onClick: ($event: any) => (_ctx.openPdf(row.id))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 2
                }, 1032, ["loading", "onClick"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  disabled: _ctx.busyId === row.id,
                  onClick: ($event: any) => (_ctx.regeneratePdf(row.id))
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 2
                }, 1032, ["disabled", "onClick"]),
                (row.type === 'invoice' && row.status === 'paid')
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      size: "small",
                      onClick: ($event: any) => (_ctx.issueAct(row.id))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (row.status === 'issued')
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 2,
                      size: "small",
                      type: "danger",
                      plain: "",
                      onClick: ($event: any) => (_ctx.cancel(row.id, row.number))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_new_tab_link, {
                  button: "",
                  to: { name: 'payments-orders-view', params: { id: row.order_id } }
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, _ctx.loading]
        ])
      ]),
      _: 1
    }, 8, ["page", "pages", "per-page", "total", "onApply", "onReset", "onPageChange"]),
    _createVNode(_component_payment_form_dialog, {
      modelValue: _ctx.confirmOpen,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.confirmOpen) = $event)),
      title: "Подтверждение оплаты счёта",
      "submit-text": "Подтвердить оплату",
      fields: _ctx.confirmFields,
      initial: _ctx.confirmInitial,
      action: _ctx.confirmAction,
      onDone: _ctx.onConfirmed
    }, null, 8, ["modelValue", "fields", "initial", "action", "onDone"])
  ], 64))
}